// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnerPurchaseOrders(_, data) {
            const response = await axios.get(`${MAIN_API}/api/purchase/order`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async getPurchaseOrderById(_, id) {
            const response = await axios.get(`${MAIN_API}/api/purchase/order/${id}`, {
                headers: { 'Content-Type': 'application/json' },
            })
            return response.data
        },
        async createPurchaseOrder(_, data) {
            const response = await axios.post(`${MAIN_API}/api/purchase/order/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getSpareBrands() {
            const response = await axios.get(`${MAIN_API}/api/sharepart/brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
